import React from "react";
import { Container } from "react-bootstrap";

const Footer = () => {
  return (
    <footer className="p-5">
      <Container>
        <p>
          Proyecto Infraestructura Natural para la Seguridad Hídrica, en alianza
          con la{" "}
          <a
            href="https://fundacionmohme.org/"
            target="_blank"
            rel="noreferrer"
          >
            Fundación Gustavo Mohme Llona
          </a>
          .
        </p>
        <p>Marzo, 2021</p>
      </Container>
    </footer>
  );
};

export default Footer;
